import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { graphql, compose } from 'react-apollo';
import Spinner from '../../spinner/spinner';
import moment from 'moment-timezone';
import { Table, Button, Modal } from 'antd';
import { PhotoImage, PhotoPlaceholder } from "../../common/photoImage/photoImage";
import { getEvangelists } from './queries/getEvangelists';
import { deactivateEvangelist } from "./mutations/deactivateEvangelist";
import { resendEvangelistInvite } from "./mutations/resendEvangelistInvite";
import { valuesComparator } from "../../../utilities/comparators";
import './evangelistsList.css';

const REVIVAL_FINISH_PHASE = 3;

class EvangelistsList extends Component {
  get dataSource() {
    return (
      this.props.data.evangelists.map((evangelist, index) => {
        return {
          id: evangelist.id,
          key: index + 1,
          photo: evangelist.photo.small,
          email: evangelist.email,
          name: evangelist.name,
          passwordCreated: evangelist.passwordCreated
        };
      })
    );
  }

  onDelete = (evangelist) => {
    Modal.confirm({
      title: `Are you sure you want to deactivate profile of ${evangelist.name}?`,
      okText: "Deactivate",
      width: 600,
      onOk: () => {
        this.props.deactivateEvangelist(this.deactivateEvangelistParams(evangelist.id)).then((response) => {
          if (response.data.deactivateEvangelist) {
            Modal.info({ content: "Evangelist has been deactivated." });
            this.props.history.push('/dashboard/admin/evangelists');
          } else {
            Modal.error({ content: "Failed to deactivate evangelist." });
          }
        }).catch((response) => {
          Modal.error({ content: response.graphQLErrors[0].details.base[0].message });
        })
      }
    });
  }

  onResendInviteClick = (evangelistId, email) => {
    this.props.resendEvangelistInvite(this.resendEvangelistInviteParams(evangelistId)).then((response) => {
      if (response && response.data && response.data.resendEvangelistInvite) {
        Modal.success({ content: `Invitation has been re-sent to ${email}` });
      } else {
        Modal.info({
          content: `Invitation has not been re-sent to ${email} as this user does not exist or he has already accepted an invitation`
        });
      }
    });
  };

  resendEvangelistInviteParams = (evangelistId) => {
    return {
      variables: {
        input: {
          id: evangelistId
        }
      }
    }
  }

  deactivateEvangelistParams = (evangelistId) => {
    return {
      variables: {
        input: {
          id: evangelistId
        }
      }
    }
  }

  get columns() {
    return (
      [
        {
          title: '#',
          dataIndex: 'key',
        }, {
          title: 'Profile pic',
          dataIndex: 'photo',
          className: 'church-members-table__photo-column',
          render: (value) => {
            return {children: value ? <PhotoImage imageURL={value}/> : <PhotoPlaceholder/>};
          }
        }, {
          title: 'Email',
          dataIndex: 'email',
          sorter: (first, second) => {
            return valuesComparator(first.email, second.email);
          }
        }, {
          title: 'Name',
          dataIndex: 'name',
          sorter: (first, second) => {
            return valuesComparator(first.name, second.name);
          }
        }, {
          title: 'Actions',
          dataIndex: '',
          key: 'x',
          render: (_value, evangelist) => {
            return (
              <div>
                <span className="m-r-12">
                  <Link to={`${this.props.match.url}/edit/${evangelist.id}`}>Edit</Link>
                </span>
                { !evangelist.passwordCreated &&
                  <span className="m-r-12">
                    <Button onClick={() => {
                      this.onResendInviteClick(evangelist.id, evangelist.email)
                    }} type="primary">
                      Re-send invitation letter
                    </Button>
                  </span>
                }
                <Button type="danger" onClick={() => this.onDelete(evangelist)}>Deactivate</Button>
              </div>
            )
          }
        }
      ]
    );
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner />;
    } else {
      return (
        <div>
          <div className="m-24">
            <div className="evangelists-list__controls align-right">
              <Link to={`${this.props.match.url}/new`}>
                <Button type="primary">Create new Evangelist profile</Button>
              </Link>
            </div>
            <Table className="groups-page__table" bordered columns={this.columns} dataSource={this.dataSource} />
          </div>
        </div>
      );
    }
  }
}

export default compose(
  graphql(getEvangelists, {
    options: {
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true
    }
  }),
  graphql(deactivateEvangelist, { name: 'deactivateEvangelist' }),
  graphql(resendEvangelistInvite, { name: 'resendEvangelistInvite' })
)(EvangelistsList)



// WEBPACK FOOTER //
// ./src/components/pages/evangelists/evangelistsList.js